import React, { useState, useEffect } from "react";

function EmailInput({ onEmailChanged, onKeyDown, inputRef }) {
  const [email, setEmail] = useState("");

  useEffect(() => {}, []);

  const emailChanged = (e) => {
    onEmailChanged(e.target.value);
    setEmail(e.target.value);
  };

  return (
    <div className="w-[296px] h-[64px]">
      <p className=" text-[12px] font-OpenSansMedium font-[600] text-inputEmailTitle">Email</p>
      <div className="w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center justify-center px-[15px]">
        <input
          ref={inputRef}
          value={email}
          type="email"
          onChange={emailChanged}
          onKeyDown={onKeyDown}
          className="w-full text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium"
          placeholder="Enter email"
        />
      </div>
    </div>
  );
}

export default EmailInput;
